import * as React from "react";
import * as moment from "moment";

import { timelineEvents } from "../../timeline_events";
import { DatePicker } from "./datepicker";
import { TimeLine } from "./timeline";


export const MOMENT_DATE_FORMAT = "MMMM Do YYYY";

const NUM_STEPS = 8;

interface State {
    startDate: moment.Moment;
}

interface Props {
    companyName?: string;
    startDate: moment.Moment;
}

export class Calculator extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = { startDate: props.startDate };
    }

    onDateChange = (startDate: moment.Moment) => {
        this.setState({ startDate });
    }

    render() {
        const { companyName } = this.props;
        const { startDate } = this.state;
        const title: string = companyName ? `${companyName} - Project Timeline` : "Project Timeline";

        return (
            <div className="timeline__wrapper">
                <div className="timeline">
                    <h3>{title}</h3>
                    <p className="timeline__subheader">Choose your ideal shoot date</p>
                    <DatePicker startDate={startDate} onDateChange={this.onDateChange}/>
                    <TimeLine startDate={startDate}/>
                    <span>* Estimate of project timeline. Dates are subject to change based on availability and additional client edits.</span>
                </div>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/ts/components/calculator/calculator.tsx